class DropCountdown extends HTMLElement {
  connectedCallback() {
    const target = this.dataset.target;
    this.targetDate = /^\d+$/.test(target) ? Number(target) : new Date(target).getTime();
    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');
    this.unitsEl = this.querySelector('.drop-countdown__units');
    this.completeMessageEl = this.querySelector('.drop-countdown__complete-message');

    if (isNaN(this.targetDate)) return;

    // Only reload if the launch happens while the page is open, so a stale cached page can't loop.
    this.reloadOnComplete = this.hasAttribute('data-reload-on-complete') && this.targetDate > Date.now();

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.targetDate - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      if (this.unitsEl) this.unitsEl.hidden = true;
      if (this.completeMessageEl) this.completeMessageEl.hidden = false;
      if (this.reloadOnComplete) setTimeout(() => window.location.reload(), 5000);
      return;
    }

    const seconds = Math.floor(remaining / 1000);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    this.setUnit(this.daysEl, days);
    this.setUnit(this.hoursEl, hours);
    this.setUnit(this.minutesEl, minutes);
    this.setUnit(this.secondsEl, secs);
  }

  setUnit(el, value) {
    if (el) el.textContent = String(value).padStart(2, '0');
  }
}

customElements.define('drop-countdown', DropCountdown);
